<template>
  <div class="device-detail-route">
    <div
      class="empty-tips"
      v-if="!tableList.length"
    >{{ $t('Common.com_no_data') }}</div>
    <div class="route-list">
      <div
        class="route-item"
        v-for="(item,index) in tableList"
        :key="index"
        :class="item.open ? 'open' : ''"
      >
        <div
          class="route-item-header"
          @click="onTab(index)"
        >
          <div class="label-content ">
            <div class="icon-content">
              <i class="icon icon-route"></i>
            </div>
            <div class="line"></div>
            <div class="title">{{item.title}}</div>
            <div class="line"> </div>
            <div class="route-num">
              <span class="count">{{item.slotCounts || 0}}</span>
              <span>/</span>
              <span class="total">6</span>
            </div>
          </div>
          <div class="tab-content">
            <div class="text">{{item.open ? $t('device_detail_route.shou_qi') : $t('device_detail_route.zhan_kai')}}</div>
            <i class="icon icon-arrow-down"></i>
          </div>
        </div>
        <slot-list
          @del="onDelCallback(item)"
          v-if="item.open"
          :data="item"
          :edit="funcView.device_detail_edit_route"
          :del="funcView.device_detail_del_route"
        ></slot-list>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import slotList from './device_detail_slot_list.vue';

export default {
  name: 'deviceDetailRoute',
  mixins: [],
  components: {
    slotList
  },
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableList: [],
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onDelCallback(item) {
      item.slotCounts--;
    },
    // 获取列表
    getTableList() {
      const { bodyNum } = this.deviceInfo;
      const url = `${apis.hlcSlotSoltListByBodyNum}/${bodyNum}`;
      this.$getJSON(url).then((res) => {
        this.tableList = this.formatList(res.data);
      });
    },
    formatList(list) {
      list.forEach((item) => {
        const { hlcCode, locationName, siteName } = item;
        const title = [hlcCode, locationName, siteName].filter(val => val !== undefined && val !== '').join(' / ');
        item.open = false;
        item.slotList = [];
        item.title = title;

      });
      return list;
    },
    onTab(index) {
      const item = this.tableList[index];
      this.$set(item, 'open', !item.open);
    }
  },
  created() {
  },
  mounted() {
    this.getFuncView('/other/device');
    this.getTableList();
  },
};
</script>

<style lang="scss">
.device-detail-route {
  padding: 24px;
  background: #fff;

  min-height: 400px;
  max-height: 700px;
  overflow-y: auto;
  position: relative;

  .empty-tips {
    width: 100%;
    height: 100px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    line-height: 100px;
    text-align: center;
    font-size: 16px;
  }

  .route-list {
    overflow: hidden;

    .route-item {
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 0 0 1px #f0f0f0 inset;

      &.open {
        .icon-arrow-down {
          transform: scale(0.7) rotate(180deg) !important;
        }
      }

      &:nth-child(n + 2) {
        margin-top: 16px;
      }

      &-header {
        width: 100%;
        height: 64px;
        padding: 20px;
        line-height: 24px;
        overflow: hidden;
        .label-content {
          float: left;
          overflow: hidden;
          height: 24px;
          .icon-content {
            float: left;
            width: 24px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            color: #00a0d9;
            .icon {
              font-size: 20px;
            }
          }
          .line {
            margin-left: 16px;
            margin-top: 2px;
            width: 2px;
            height: 20px;
            background: #f0f0f0;
            float: left;
          }
          .title {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            font-weight: bold;
            margin-left: 16px;
          }
          .route-num {
            float: left;
            margin-left: 16px;
            color: #818181;
            font-weight: bold;
            .count {
              color: #00a0d9;
            }
          }
        }

        .tab-content {
          float: right;
          cursor: pointer;

          .text {
            float: left;
            color: #818181;
            font-size: 12px;
            margin-right: 5px;
            font-weight: bold;
          }

          .icon {
            float: left;
            font-size: 12px;
            color: #202945;
            transform: scale(0.7) rotate(0deg);
          }
        }
      }

      .slot-list {
        overflow: hidden;
        padding: 0 0 16px 16px;
        margin-bottom: 20px;

        .slot-item {
          position: relative;
          width: 184px;
          height: 112px;
          float: left;
          border-radius: 4px;
          margin-top: 16px;
          margin-right: 16px;
          overflow: hidden;
          box-shadow: 0 0 0 1px rgba(179, 179, 179, 0.2) inset;

          &-header {
            position: relative;
            z-index: 10;
            height: 28px;
            line-height: 28px;
            overflow: hidden;
            background: rgba(77, 77, 77, 0.9);
            .char {
              float: left;
              color: #fff;
              font-size: 14px;
              font-weight: bold;
              padding: 0 8px;
            }
            .line {
              float: left;
              background: rgba(255, 255, 255, 0.9);
              width: 1px;
              height: 12px;
              margin-top: 8px;
              margin-right: 8px;
            }
            .title {
              overflow: hidden;
              color: #fff;
              font-size: 14px;
            }
          }

          &-footer {
            position: absolute;
            z-index: 10;
            left: 1px;
            right: 1px;
            bottom: 1px;
            margin: auto;
            height: 19px;
            line-height: 20px;
            color: #4d4d4d;
            font-size: 12px;
            text-align: center;
          }

          .slot-img {
            position: absolute;
            z-index: 0;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            max-width: 95%;
            max-height: 95%;
          }
        }
      }
    }
  }
}
</style>
